export const formatNumber = (n: number): string => n.toLocaleString('en-US');
